import countries from 'i18n-iso-countries';
import en from 'i18n-iso-countries/langs/en.json';
import es from 'i18n-iso-countries/langs/es.json';

import { DEFAULT_LOCALE } from 'configs/i18n';
import { IOption } from 'types/common.types';

// Register locales once (side effect)
countries.registerLocale(en);
countries.registerLocale(es);

export function getCountries(locale = DEFAULT_LOCALE): IOption[] {
  const names = countries.getNames(locale, { select: 'official' });
  return Object.entries(names).map(([code, name]) => ({ label: name, value: code }));
}

export function getCountryName(code: string, locale = DEFAULT_LOCALE): string | null {
  return countries.getName(code.toUpperCase(), locale) || code || null;
}

export default countries;
